import { useTranslation } from "react-i18next";
import { ListingBadgeTheme } from "../../helpers/constants/listingBadges";

export const ListingBadgePill = ({ badge }: { badge: ListingBadgeTheme }) => {
  const { t } = useTranslation();

  return (
    <div
      className={`absolute top-2.5 left-2.5 z-10 ${badge.badgeGradient} text-white px-2.5 py-1 rounded-full text-xs font-bold flex items-center gap-1 shadow-md`}
    >
      <span aria-hidden="true">{badge.emoji}</span>
      {t(badge.labelKey, badge.labelFallback)}
    </div>
  );
};
